import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";

const AccumulatorWidgetAsyncComponent = AsyncComponent(async () => import('./accumulator-widget' /* webpackChunkName: "accumulator-widget" */ ));

export const AccumulatorWidgetAsync = (props) => {
  return <AccumulatorWidgetAsyncComponent {...props}/>
};
